var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appointmentParticipant)?_vm._l((_vm.chips),function(v,i){return _c('dashboard-chip',{key:i,attrs:{"i":i,"value":v}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }